import BaseEntity from "./BaseEntity";
import { InteractionType } from "./InteractionType";

/** Means unbounded, not a real ceiling -- the backend synthesizes this for any model saved with no quotas. */
export const MODEL_QUOTA_NO_LIMIT = 2147483647;

export enum ModelComputeFrequency {
    None = 0,
    Daily = 1,
    Weekly = 2,
}

export class ModelComputeOptionEnabled {
    modelComputeOption: ModelComputeOption;
    enabled: boolean;
}

interface ModelComputeStructureMember {
    organizationStructureMemberId: string;
}

export enum ModelOption {
    AdverseEvents = "AdverseEvents",
    EddyEffect = "EddyEffect",
    Hipaa = "Hipaa",
    SafetyEvents = "SafetyEvents",
    Sentiment = "Sentiment",
    Summary = "Summary",
    Topic = "Topic",
    Driver = "Driver",
    TopicLLM = "TopicLLM",
    Voicemail = "Voicemail",
    IVR = "IVR",
    ContactType = "ContactType",
    SpeakerIdentification = "SpeakerIdentification",
    LuceneOrLLM = "LuceneOrLLM",
    Redaction = "Redaction",
}

export class ModelComputeOption extends BaseEntity {
    modelOption: string;
    modelQuota?: number;
    leadClassifierName?: string;
    quotaFrequency?: ModelComputeFrequency;
    modelComputeStructureMembers: ModelComputeStructureMember[] | null;
    modelComputeQuotas: ModelComputeQuota[] | null;
}

export interface ModelComputeQuota extends BaseEntity {
    modelQuota: number;
    quotaFrequency: ModelComputeFrequency;
    modelComputeStructureMembers: ModelComputeStructureMember[];
}

export class TranscriptionFilterOptionEnabled {
    transcriptionFilterOption: TranscriptionFilterOption;
    enabled: boolean;
}

export class TranscriptionFilterOption extends BaseEntity {
    mediaType: InteractionType;
    filterType: FilterTypes;
    filterValue: number;
    organizationId: string;
}

export class RedactionOption extends BaseEntity {
    redactionOption: string;
}

export class PIIExtractionOption extends BaseEntity {
    extractionOption: string;
}

export enum FilterTypes {
    WordCount,
    ExchangeCount,
}

export interface MlModelForLlmExecution {
    id: string;
    name: string;
    hasResultsDuringLlmExecution: boolean;
    hasComputeRestrictions: boolean;
}
